export enum ColorsEnum {
    // Couleurs principales
    PRIMARY = "#5588FB",
    PRIMARY_FOCUS = "#416EDC",
    PRIMARY_CONTENT = "#ffffff",

    // Couleurs secondaires
    SECONDARY = "#FD638F",
    SECONDARY_FOCUS = "#E44A73",
    SECONDARY_CONTENT = "#ffffff",

    // Couleurs d'accentuation
    ACCENT = "#F9A826",
    ACCENT_FOCUS = "#E4951C",
    ACCENT_CONTENT = "#ffffff",

    // Couleurs neutres
    NEUTRAL = "#3D4451",
    NEUTRAL_FOCUS = "#2B2F37",
    NEUTRAL_CONTENT = "#ffffff",

    // Couleurs de base
    BASE_100 = "#ffffff",
    BASE_200 = "#F1F5F9",
    BASE_300 = "#E2E8F0",
    BASE_CONTENT = "#1F2937",

    // Couleurs de statut
    INFO = "#3ABFF8",
    INFO_FOCUS = "#2A9ED5",
    INFO_CONTENT = "#ffffff",

    SUCCESS = "#36D399",
    SUCCESS_FOCUS = "#2AB07C",
    SUCCESS_CONTENT = "#ffffff",

    WARNING = "#FBBD23",
    WARNING_FOCUS = "#D69E1F",
    WARNING_CONTENT = "#ffffff",

    ERROR = "#F87272",
    ERROR_FOCUS = "#E15555",
    ERROR_CONTENT = "#ffffff",
}
